// src/views/Login.jsx
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
// import api from '../services/api'
import { saveUserToStorage } from '../services/auth'
import api, { setAuthToken } from '../services/api';
import './Login.css'
import mundiembyLogo from '../assets/mundiemby-logo.png'  // Pon aquí la ruta correcta del logo


function Login() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const res = await api.post('/usuarios/login', { username, password });

const usuario = res.data.usuario || res.data; // soporte flexible
const token = res.data.token;

setAuthToken(token);
localStorage.setItem('token', token);

saveUserToStorage({ ...usuario, token });
console.log('👤 Usuario guardado en localStorage:', { ...usuario, token });

if (usuario.isAdmin) {
  navigate('/admin/sesiones');
} else {
  navigate('/SeleccionarPerfil');
}

    } catch (err) {
      setError('Usuario o contraseña incorrectos')
    }
  }

  return (
    <div className="login-page">
    <div className="login-container">
      <img src={mundiembyLogo} alt="MundiEmby Logo" className="login-logo" />
      <h2>MundiEmby</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Usuario"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Entrar</button>
        {error && <p className="error">{error}</p>}
      </form>
    </div>
    </div>
  )
}

export default Login